import React from 'react';
import { Typography } from '@saviynt/design-system';

import { type UserMessage } from '../../../context';

import './UserRequest.css';

interface UserRequestProps {
  message: UserMessage;
}

function UserRequest({ message }: UserRequestProps) {
  return (
    <div className='Ispm-UserRequest'>
      <Typography kind='body2' className='Ispm-UserRequest-text'>
        {message.text}
      </Typography>
    </div>
  );
}

export default UserRequest;
